// extracted by mini-css-extract-plugin
export default {"header":"header_header__9VcW0","title":"header_title__4c-kP"};